import PanelBottom from "./SVG/panel-bottom.svg?react";

const PanelBottomIcon = () => {
  return <PanelBottom />;
};

export default PanelBottomIcon;
